import { createFileRoute } from "@tanstack/react-router";
import { JoinPage } from "../../../features/ambassadors";

export const Route = createFileRoute("/$lang/_layout/ambassadors")({
  component: JoinPage,
});
